<template>
  <el-table
    ref="elTable"
    :data="tableData"
    :style="`width: ${tableWidth}`"
    stripe
    class="egl-table list-table"
  >
    <el-table-column :label="$locale('global.change')" width="80" align="center" v-if="isShowChange">
      <template slot-scope="scope">
        <i class="el-icon-circle-check change" v-show="!scope.row.isApprove"></i>
      </template>
    </el-table-column>
    <el-table-column
      v-for="(item, idx) in tableHeaderData"
      :key="idx"
      :prop="item.prop"
      :label="item.label"
      :min-width="item.width"
      :formatter="item.formatter"
    />
    <el-table-column :label="$locale('global.control')" width="150" align="center">
      <template slot-scope="scope">
        <div class="handle">
          <a @click="edit(scope)">{{ $locale("global.edit") }}</a>
          <el-divider direction="vertical" v-if="!noDelete"></el-divider>
          <a @click="deleteVersion(scope)" v-if="!noDelete">{{ $locale("global.delete") }}</a>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  methods: {
    edit(itemContext) {
      const { row } = itemContext;
      this.$parent.editAction(row);
    },
    deleteVersion(itemContext) {
      const { $index, row } = itemContext;
      this.$parent.delAction(row, $index);
    }
  },
  props: {
    tableHeaderData: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableWidth: {
      type: [String, Number],
      default: ""
    },
    noDelete: {
      type: Boolean,
      default: false,
    },
    isShowChange: {
      type: Boolean,
      default: false
    }
  },
};
</script>
